import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Edge AI Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#0d1117',
          color: 'white',
          gap: '16px',
          fontFamily: 'Inter, sans-serif'
        }}>
          <img
            src="/StratusEdgeFinal_whiteupscaled.png"
            alt="Edge AI"
            style={{ width: '120px' }}
          />
          <h2 style={{ margin: 0, fontWeight: 600 }}>
            Something went wrong
          </h2>
          <p style={{
            color: 'rgba(255,255,255,0.5)',
            margin: 0,
            fontSize: '14px'
          }}>
            Please refresh the page to continue.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '10px 24px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
